import {} from '@mui/system';
import { Datagrid, List, TextField, BulkDeleteButton, usePermissions, FunctionField } from 'react-admin';
import { IconButton } from '@mui/material';
import { BiTrash } from 'react-icons/bi';
import axios from 'axios';
import constants from '../../../constants';
import { useNotify, useRefresh } from 'react-admin';

const TrialUsersList = () => {
	const { permissions } = usePermissions();
	const notify = useNotify();
	const refresh = useRefresh();
	
	// Control delete functionality based on permissions
	const canDelete = true;

	const handleDelete = async (record: any) => {
		
		if (window.confirm('האם אתה בטוח שברצונך למחוק משתמש זה?')) {
			try {
				await axios.delete(`${constants.API_URL}/setting/trial`, {
					data: { email: record.email },
					headers: {
						Authorization: `Bearer ${localStorage.getItem('token')}`
					}
				});
				notify('משתמש נמחק בהצלחה', { type: 'success' });
				refresh();
			} catch (error) {
				notify('שגיאה במחיקת המשתמש', { type: 'error' });
			}
		}
	};

	return (
		<List perPage={10000} pagination={false}>
			<Datagrid bulkActionButtons={canDelete ? <BulkDeleteButton /> : false}>
				<TextField source="email" />
				<TextField source="type" />
				{canDelete && (
					<FunctionField
						render={(record: any) => (
							<IconButton
								onClick={(e) => {
									e.stopPropagation();
									handleDelete(record);
								}}
								color="error"
								title="מחק משתמש"
							>
								<BiTrash />
							</IconButton>
						)}
					/>
				)}
			</Datagrid>
		</List>
	);
};

export default TrialUsersList;
